import React from "react";
import { connect } from "react-redux";
import { getInvitationsList } from "../../../store/actions/dataActions";
import Navbar from "../Navbar/Navbar";
import NavItem from "../Navbar/NavItem";
import DropdownMenu from "../Navbar/DropDownMenu";
import LanguagePopover from "../../components/LanguagePopOver/LanguagePopOver";
//import DropDownAddFriendMenu from "../../components/Navbar/DropDownAddFriendMenu";
//import DropDownAddDeviceMenu from "../../components/Navbar/DropDownAddDeviceMenu";
import DropdownNotificationMenu from "../Navbar/DropDownNotificationMenu";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
const NavMenu = ({ socket, invitationFriendList,matches }) => {
  console.log("invitationFriendListNavMenu", invitationFriendList);
  let count = invitationFriendList.length;
  function notificationsLabel(count) {
    if (count === 0) {
      return "no notifications";
    }
    if (count > 99) {
      return "more than 99 notifications";
    }
    return `${count} notifications`;
  }

  return (
    <>
      <Navbar>
        <span
          style={{
            fontSize: "25px",
            lineheight: "1",
            fontFamily: "Rubik , sans-serif",
            position: "absolute",
            fontWeight: "bold",
            left: "6vw",
            top: "0%",
            transform: "translate(-30%,50%)",
          }}
        >
          Vizia.
        </span>

        {/* Friends' request notification */}
        <IconButton aria-label={notificationsLabel(count)}>
          <Badge
            badgeContent={count}
            color="primary"
            style={{ transform: matches?"translate(64px,-10px)":"translate(78px,-10px)" }}
          ></Badge>
        </IconButton>
        <NavItem
          icon={
            <svg
              viewBox="0 0 28 28"
              style={{ transform: matches?"translate(1vw,1.1vh)":"translate(150%,50%)",border:"1px solid none" }}
            >
              <path d="M7.847 23.488C9.207 23.488 11.443 23.363 14.467 22.806 13.944 24.228 12.581 25.247 10.98 25.247 9.649 25.247 8.483 24.542 7.825 23.488L7.847 23.488ZM24.923 15.73C25.17 17.002 24.278 18.127 22.27 19.076 21.17 19.595 18.724 20.583 14.684 21.369 11.568 21.974 9.285 22.113 7.848 22.113 7.421 22.113 7.068 22.101 6.79 22.085 4.574 21.958 3.324 21.248 3.077 19.976 2.702 18.049 3.295 17.305 4.278 16.073L4.537 15.748C5.2 14.907 5.459 14.081 5.035 11.902 4.086 7.022 6.284 3.687 11.064 2.753 15.846 1.83 19.134 4.096 20.083 8.977 20.506 11.156 21.056 11.824 21.986 12.355L21.986 12.356 22.348 12.561C23.72 13.335 24.548 13.802 24.923 15.73Z"></path>
            </svg>
          }
        >
          {invitationFriendList.length!==0 &&( <DropdownNotificationMenu
            invitationFriendList={invitationFriendList}
          ></DropdownNotificationMenu>)}
        </NavItem>

        <LanguagePopover />

        {/* Menu */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 512"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-circle"
          style={{ transform: "translate(-10px,19px)" }}
        >
          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
          <path
            fillRule="evenodd"
            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
          />
        </svg>
        <p>
          {localStorage.getItem("firstName")} {localStorage.getItem("lastName")}
        </p>

        <NavItem
          icon={
            <>
              <svg  style={{ transform: "translate(0,0.6vh)",border:"1px solid none" }} viewBox="0 0 320 512">
                <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
              </svg>
            </>
          }
        >
          <DropdownMenu socket={socket}></DropdownMenu>
        </NavItem>
      </Navbar>
    </>
  );
};
function mapStoreStateToProps({ call, data }) {
  return {
    ...call,
    ...data,
  };
}

export default connect(mapStoreStateToProps, {
  getInvitationsList,
})(NavMenu);
